module.exports = __webpack_public_path__ + "img/feishu_200x200@2x.d3cf84e6.png";